import { Component, OnInit, inject,  model } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { BookService } from 'src/app/services/book.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
    selector: 'kbm-is-interested-chips',
    templateUrl: './is-interested-chips.component.html',
    styleUrls: ['./is-interested-chips.component.scss'],
    standalone: true,
    imports: [
        MatChipsModule,
        MatIconModule,
        MatOptionModule,
        MatSelectModule,
        MatFormFieldModule,
    ]
})
export class IsInterestedChipsComponent implements OnInit {

  isInterested = model.required<string[]>();


  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;

  allUsers: string[] = [];

  bookService = inject(BookService);
  messageService = inject(MessageService);

  ngOnInit(): void {
    this.loadUserList();
  }

  async loadUserList() {
    try {
      const users = await this.bookService.getUsers();
      this.allUsers = users.map(u => u.username);
    }
    catch (err) {
      console.error(err);
    }
  }

  onIsInterestedChange(evt: any) {
    this.isInterested.set(evt);
  }

}
